<template>
  <div>
    <section class="hello hero-style-2 home-wrap">
      <el-carousel :autoplay="true" indicator-position="none">
        <el-carousel-item class="hero-slider" v-for="(item,index) in banner" :key="index">
          <a :href="item.NewsURL" target="_blank">
            <img :src="item.imgUrl" alt class="slider-bg"/>
            <div class="banner-info slide">
              <div class="container">
                <div class="row">
                  <div class="col col-md-8 slide-caption" :class="item.CSSOne">
                    <div class="slide-title">
                      <h2>{{item.Title}}</h2>
                    </div>
                    <div class="slide-subtitle">
                      <p>{{item.Summary}}</p>
                    </div>
                    <div class="slide-subtitle">
                      <p>{{item.title2}}</p>
                      <p>{{item.title3}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </el-carousel-item>
      </el-carousel>
    </section>
    <div class="PhonePage">
      <div class="phoneIntro">
        <div class="IntroTitle">南京金陵饭店集团有限公司</div>
        <div class="IntroWeb">欢迎访问南京金陵饭店集团官方网站</div>
        <div class="IntroContent">
          2002年10月经省政府批准，南京金陵饭店集团有限公司在南京金陵饭店的基础上组建成立。
          2018年6月，江苏省国信集团有限公司、江苏交通控股有限公司、徐州矿务集团有限公司所属16家企业酒店和旅游类资产整合注入南
          集团主业：酒店、旅游、养老。
        </div>
        <div class="IntroMore" @click="KnowMore">了解更多</div>
      </div>
      <div class="PhoneList">
        <div class="ListTitle">{{DataList.Name}}</div>
        <div class="ListBox">
          <div :class="index == btnNum ?'phoneActive listItems':'listItems'" v-for="(items,index) in subList" :key="index" @click="redNewsList(index,items)">{{items.Name}}</div>
        </div>
        <div class="phListCont">
          <div class="contentLi" v-for="(items,index) in AllNewList" :key="index">
            <div class="contLiTitle" @click="redDetail(items)">{{items.Title}}</div>
            <div class="contLiDate">{{items.ReasTime}}</div>
          </div>
          <div class="redMore" @click="readListMore">更多 +</div>
        </div>
      </div>
    </div>
    <!--广告浮动-->
<!--    <div id="thediv" ref="thediv" style="position: absolute; z-index: 111; left: 0; top: 0;" v-show="thedivShow" @mouseover="clearFdAd" @mouseout="starFdAd">-->
<!--      <img src="../assets/images/home/ads.jpg" @click="stydyBtn"/>-->
<!--      <div style="cursor: pointer;text-align: right;font-size:12px;color: #999999" @click="thedivShow = false">关闭</div>-->
<!--    </div>-->
<!--    <div id="thediv" ref="thediv" style="position: absolute; z-index: 111; left: 0; top: 0;" v-show="thedivShow" @mouseover="clearFdAd" @mouseout="starFdAd">-->
<!--      <img src="../assets/icon/tubiao.jpg" @click="stydyBtn"/>-->
<!--      <div style="cursor: pointer;text-align: right;font-size:12px;color: #999999" @click="thedivShow = false">关闭</div>-->
<!--    </div>-->
  </div>
</template>

<script>
  import * as api from '../api/api.js'
  import * as utils from '../utils.js'
  var interval;
export default {
  name: 'HelloWorld',
  data () {
    return {
      // pic:[
      //   {avatar:require("../assets/images/bn/bn2.jpg")},
      //   {avatar:require("../assets/images/bn/bn1.jpg")},
      //   {avatar:require("../assets/images/bn/bn4.jpg")},
      // ],
      banner:[],
      AllBaner:[],
      DataList:[],
      DataListTwo:[],
      SecondKey:'',
      subList:[],
      btnNum:0,
      AllNewList:[],
      // // 广告浮动
      // xPos: 50,
      // yPos: 50,
      // xin:true,
      // yin :true ,
      // step: 1,
      // delay: 18,
      // height: 0,
      // Hoffset: 0,
      // Woffset: 0,
      // yon: 50,
      // xon: 50,
      // pause: true,
      // thedivShow: true
    }
  },
  created(){
    this.getBanners()
    this.getSub()
    this.GetNewsList()
  },
  mounted(){
    // interval = setInterval(this.changePos, this.delay)
    // // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    // this.$once('hook:beforeDestroy', () => {
    //   clearInterval(interval);
    // })
  },
  methods:{
    getBanners(){
      var Params ={
        igid:-1,
        key:'banner'
      }
      api.getContent(Params).then(res =>{
        if(res.Status === 100){
          this.AllBaner = JSON.parse(res.Data.Value)
          this.AllBaner.forEach((vv) => {
            if((vv.show).toString() === 'true'){
              vv.imgUrl = vv.imgUrl + '?height=' + document.body.clientHeight
              this.banner.push(vv)
            }
          })
        }else {
          this.$message({message: res.Msg,type: 'warning'})
        }
      })
    },
    getSub(){
      var storage =  utils.storage.get('jinLin_menu')
      storage.data.forEach((vv)=>{
        if(vv.Key ==='NewCenter'){
          this.DataList = vv
          vv.subMenu .forEach((dd,index)=>{
            if(index <2){
              this.subList.push(dd)
            }
          })
        }else if(vv.Key ==='AboutUs'){
          this.DataListTwo = vv
        }
      })
    },
    GetNewsList(items){
      var NewsId = ''
      if(this.btnNum === 0){
        NewsId = this.subList[0].Id
        this.SecondKey = this.subList[0].Key
      }else {
        NewsId = items.Id
        this.SecondKey = items.Key
      }
      var params = {
        igid: NewsId,
        Page: 1,
        PageSize: 4,
      }
      api.getNewsList(params).then(res =>{
        if(res.Status === 100){
          res.Data.DataList.forEach((vv)=>{
            var newMsg = this.$moment(vv.ReleaseDate).format('YYYY-MM-DD');
            vv.ReasTime = newMsg
          })
          this.AllNewList = res.Data.DataList
        }else {
          this.$message({message: res.Msg,type: 'warning'})
        }
      })
    },
    KnowMore(){
      this.$router.push({name: 'info', params: {fkey:'AboutUs', key: this.DataListTwo.subMenu[0].Key}})
    },
    redNewsList(index,items){
      this.btnNum = index
      this.GetNewsList(items)
    },
    redDetail(items){
      if(items.IsWeixin){
        window.location.href = JSON.parse(items.HtmlContent).url
      }else {
        this.DataList.subMenu.forEach((vv)=>{
          if(vv.Id === items.igId){
            this.SecondKey = vv.Key
          }
        })
        this.$router.push({name: 'newsDetail', params: {fkey:'NewCenter', key: this.SecondKey, newsId: items.Id}})
      }
    },
    readListMore(){
      this.$router.push({name: 'news', params: {fkey:'NewCenter', key: this.SecondKey}})
    },
    // 广告浮动
    // changePos() {
    //   let width = document.documentElement.clientWidth;
    //   let height = document.documentElement.clientHeight;
    //   this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
    //   this.Woffset = this.$refs.thediv.offsetWidth;
    //
    //   // 滚动部分跟随屏幕滚动
    //   // this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
    //   // this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";
    //
    //   // 滚动部分不随屏幕滚动
    //   this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft) + "px";
    //   this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop) + "px";
    //
    //   if (this.yon) {
    //     this.yPos = this.yPos + this.step;
    //   } else {
    //     this.yPos = this.yPos - this.step;
    //   }
    //   if (this.yPos < 0) {
    //     this.yon = 1;
    //     this.yPos = 0;
    //   }
    //   if (this.yPos >= (height - this.Hoffset)) {
    //     this.yon = 0;
    //     this.yPos = (height - this.Hoffset);
    //   }
    //
    //   if (this.xon) {
    //     this.xPos = this.xPos + this.step;
    //   } else {
    //     this.xPos = this.xPos - this.step;
    //   }
    //   if (this.xPos < 0) {
    //     this.xon = 1;
    //     this.xPos = 0;
    //   }
    //   if (this.xPos >= (width - this.Woffset)) {
    //     this.xon = 0;
    //     this.xPos = (width - this.Woffset);
    //   }
    // },
    // clearFdAd() {
    //   clearInterval(interval)
    // },
    // starFdAd() {
    //   interval = setInterval(this.changePos, this.delay)
    // },
    //跳转到党史课堂
    // stydyBtn(){
    //   this.$router.push({name: 'news', params:{fkey:'PartyBuilding',key: 'THeducation'}})
    // },
  }
}
</script>

<style>
.slider-bg{
  height: 100%;
  width: 100%;
}
.el-carousel__arrow{
  background: rgba(176,161,109,0.8);
  width: 55px;
  height: 55px;
  border-radius: 50%;
  font-size: 16px;
}
.banner-info{
  position: absolute!important;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.home-wrap .slide-caption>div *{
  -webkit-animation: fadeInLeft 1.5s both;
  animation: fadeInLeft 1.5s both;
}
.slide-caption{
  text-align: left;
}
#thediv {
  z-index: 100;
  position: absolute;
  top: 43px;
  left: 2px;
  height: 350px;
  width: 430px;
  cursor: pointer;
}
#thediv img{
  width: 100%;
  border-radius: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/home.vue